import { Box, Paper, Typography } from '@material-ui/core'
import moment from 'moment-timezone'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Api from '../Apis/api.service'
import { url2 } from '../utils'
import Footer from './partials/Footer'
import IntroResolutions, { BaseUnit } from './partials/IntroResolutions'
import Title from './partials/Title'
import useStyles, { customTheme } from './styles/styles'

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { PostalVotingPage } from './partials/PostalVoting'
import { PouvoirAG } from './partials/PouvoirAG'
import { ConvocationPaperContainer } from './convocation_paper'
import { TIMEZONE } from '../config'
const ConvocationDigital = (props) => {
  const { ag_id, coowner_id } = useParams()
  const [details, setDetails] = useState({})
  const [pvagsConvocation, setPvagsConvocation] = useState({})

  const getDetails = async () => {
    const res = await Api.ags.getDetailsCoownerAndAgs({ ag_id, coowner_id })
    if (res.status == 200) {
      setDetails(res.data)
    }
    const resPvConvocation = await Api.pvags.getPvagsconvocation(ag_id)
    if (resPvConvocation.status == 200) {
      setPvagsConvocation(resPvConvocation.data)
    }
  }
  useEffect(() => {
    getDetails()
  }, [])

  const Convocation = () => {
    const date = moment.utc(details?.date).tz(TIMEZONE).format('LLL')
    return (
      <BaseUnit>
        <div
          style={{
            marginTop: '-140px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={url2} width="200" />
        </div>
        <br />
        <br />
        <Typography variant="h5">
          <b>
            Attestation de remise de convocation avec signature électronique
          </b>
        </Typography>
        <br />
        <br />
        <div className="pdf-letter__header" style={{ maxWidth: '50%' }}>
          <Typography variant="body2">
            <b>
              Copropriété située au : {details?.adresse} - {details?.ville}{' '}
            </b>
            <Typography variant="body2"></Typography>
            <b>Copropriétaire : {details?.coproprietaire} </b>
          </Typography>
          <Typography variant="body2">
            <b>Assemblée Générale du : {date}</b>
          </Typography>
        </div>

        <br />
        <br />

        <Typography variant="body2">Madame, Monsieur,</Typography>
        <br />
        <Typography variant="body2">
          J’ai souhaité recevoir la convocation à l’assemblée générale par
          remise directe. Ma demande porte sur l’assemblée générale mentionnée
          ci-dessous.
        </Typography>

        <Typography variant="body2">
          Je vous prie, par la présente, de bien vouloir trouver une attestation
          signée confirmant la réception de la convocation dans les délais
          légaux, au titre de la loi du 10 juillet 1965, modifiée. J’ai noté que
          je dispose de la possibilité de demander une convocation classique par
          courrier recommandé avec accusé de réception dans le futur. J’ai noté
          qu’il est également possible de télécharger la convocation
          électronique sur mon espace sécurisé (dit « extranet »).
        </Typography>

        <Typography variant="body2">
          J’ai noté que les informations contenues dans le présent courrier, et
          à l’occasion de la remise de tout document, sont destinées à n’être
          utilisées par le syndic que pour la gestion de sa relation avec son
          client. Conformément à la "Loi Informatique et Libertés" du 6 janvier
          1978 modifiée, je suis informé(e) que je dispose d'un droit d'accès,
          de rectification et d'opposition aux données me concernant.
        </Typography>
        <br />
        <Typography variant="body2">
          Je vous prie d’agréer, Madame, Monsieur, l’expression de mes
          sentiments respectueux.
        </Typography>

        <br />
        <br />

        <Typography variant="body2">
          <b>Signé à Paris, le {moment.tz(TIMEZONE).format('LL')}</b>
        </Typography>

        <Typography variant="body2">
          <b>{details?.full_name}</b>
        </Typography>

        <Typography
          style={{
            fontSize: '50px',
            color: 'white',
            '-webkit-print-color-adjust': 'exact',
          }}
        >
          [[s|0]]
        </Typography>
      </BaseUnit>
    )
  }
  const { withMargin } = useStyles()

  const theme = customTheme(details?.pv_font_size)

  return (
    <MuiThemeProvider theme={theme}>
      <Box component={Paper}>
        <div className="page-header"></div>
        <table className={withMargin}>
          <thead>
            <tr>
              <td>
                <div className="page-header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Convocation />
                <ConvocationPaperContainer
                  details={details}
                  pvagsConvocation={pvagsConvocation}
                  showLogo={false}
                />
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div style={{ height: '50px' }}>&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>

        <Footer />
      </Box>
    </MuiThemeProvider>
  )
}
export default ConvocationDigital
